"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketRuleRecordCalcMultiple = void 0;
const market_rule_record_field_1 = require("./market-rule-record-field");
class MarketRuleRecordCalcMultiple extends market_rule_record_field_1.MarketRuleRecordField {
    /**
     * Constructor
     * @param obj Source object for fields initialiazation
     */
    constructor(obj) {
        super(obj);
        if (obj) {
            this.value1 = obj.value1;
            this.value2 = obj.value2;
        }
    }
    getValue(context) {
        let value = null;
        const value1 = context.evaluateValue(this.value1);
        if (value1 != null) {
            const value2 = context.evaluateValue(this.value2);
            if (value2 != null) {
                value = value1 * value2;
            }
        }
        return value;
    }
}
exports.MarketRuleRecordCalcMultiple = MarketRuleRecordCalcMultiple;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFya2V0LXJ1bGUtcmVjb3JkLWNhbGMtbXVsdGlwbGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi9zcmMvY29udGVudC9oaXN0b3JpY2FsLXByaWNpbmcvdGltZS1zZXJpZXMvc2VydmljZXMvcnVsZS1lbmdpbmUtc2VydmljZS9jbGFzc2VzL21hcmtldC1ydWxlLXJlY29yZC1jYWxjLW11bHRpcGxlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUNBLHlFQUFtRTtBQUVuRSxNQUFhLDRCQUE2QixTQUFRLGdEQUFxQjtJQUluRTs7O09BR0c7SUFDSCxZQUFtQixHQUEyQztRQUMxRCxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUM7UUFFWCxJQUFJLEdBQUcsRUFBRSxDQUFDO1lBQ04sSUFBSSxDQUFDLE1BQU0sR0FBRyxHQUFHLENBQUMsTUFBTyxDQUFDO1lBQzFCLElBQUksQ0FBQyxNQUFNLEdBQUcsR0FBRyxDQUFDLE1BQU8sQ0FBQztRQUM5QixDQUFDO0lBQ0wsQ0FBQztJQUVNLFFBQVEsQ0FBQyxPQUFZO1FBQ3hCLElBQUksS0FBSyxHQUFHLElBQUksQ0FBQztRQUNqQixNQUFNLE1BQU0sR0FBRyxPQUFPLENBQUMsYUFBYSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQztRQUNsRCxJQUFJLE1BQU0sSUFBSSxJQUFJLEVBQUUsQ0FBQztZQUNqQixNQUFNLE1BQU0sR0FBRyxPQUFPLENBQUMsYUFBYSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQztZQUNsRCxJQUFJLE1BQU0sSUFBSSxJQUFJLEVBQUUsQ0FBQztnQkFDakIsS0FBSyxHQUFHLE1BQU0sR0FBRyxNQUFNLENBQUM7WUFDNUIsQ0FBQztRQUNMLENBQUM7UUFDRCxPQUFPLEtBQUssQ0FBQztJQUNqQixDQUFDO0NBQ0o7QUE1QkQsb0VBNEJDIn0=